import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
// ------ Styles ------ //
import styles from './QualifierManager.module.css'
// ------ Components ------ //
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import QualifierSetup from '../../../components/LeadCapture/QualifierManager/QualifierSetup'
import QualifierSelection from '../../../components/LeadCapture/QualifierManager/QualifierSelection'

const QualifierManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const exhibitor = location.state
    const [loaded, setLoaded] = useState(false)
    const [qualifierTypes, setQualifierTypes] = useState([])
    const [qualifiers, setQualifiers] = useState([])
    const [selections, setSelections] = useState([])
    const [newSelection, setNewSelection] = useState('')
    const [create, setCreate] = useState(false)
    const [createSelection, setCreateSelection] = useState(false)
    const [editingId, setId] = useState();
    const [editingSelectionId, setSelectionId] = useState();
    const [formData, setFormData] = useState(
        {
            id: null,
            exhibitorId: exhibitor.id,
            exhibitorEmail: exhibitor.email,
            name: null,
            displayOrder: null,
            qualifierType: {},
            typeName: null,
            selections: [],
            visible: true,
        }
    )
    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            var foundType = qualifierTypes.find((item) => item.name === e.target.value);
            if (foundType) {
                setFormData({
                    ...formData,
                    ['type']: foundType,
                    ['typeName']: foundType.name,
                })
            }
            else {
                setFormData({
                    ...formData,
                    ['type']: null,
                    ['typeName']: null,
                })
            }
        }
        else if (e.target.type === 'checkbox') {
            formData[e.target.name] = e.target.checked;
            setFormData({
                ...formData
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const handleSelectionChange = (e) => {
        if (e.target.value && e.target.value.length > 0) {
            setNewSelection(e.target.value);
        }

    }
    const cancelEdit = e => {
        if (e.currentTarget && e.currentTarget !== undefined)
        {
            e.preventDefault()
        }
        let divId = e.currentTarget && e.currentTarget !== undefined ? e.currentTarget.id : e.displayOrder ;
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(qualifiers)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (!items.some(editableCheck)) {
            return
        }
        filtered.editable = false
        setId(null)
    }
    const editQualifier = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(qualifiers)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (items.some(editableCheck)) {
            return
        }
        filtered.editable = true
        setId(divId)
    }
    const deleteQualifier = id => {
        //e.preventDefault()
        let divId = id//e.currentTarget.id;
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(qualifiers);
        let filtered = items.filter(qual => divId === qual.id)[0]// items[divId];
        let trimmed = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i] === filtered) {
                trimmed = items.splice(i, 1);
                i--;
            }
        }
        setQualifiers(items);
        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (!items.some(editableCheck)) {
            return
        }
        try {
            leadCaptureService.deleteQualifier(filtered.id);
        } catch (err) {
            //console.log(err)
        }

        filtered.editable = false;
        setId(null);
    };
    const clearForm = () => {
        setFormData({
            id: null,
            exhibitorId: exhibitor.id,
            exhibitorEmail: exhibitor.email,
            name: null,
            displayOrder: null,
            type: {},
            typeName: null,
            selections: [],
            visible: true,
        })
        setSelections([]);
    }

    const createSaveRequest = () => {
        const fieldsSave = {
            'id': formData.id,
            'exhibitorId': formData.exhibitorId,
            'exhibitorEmail': formData.exhibitorEmail,
            'name': formData.name,
            'displayOrder': formData.displayOrder ? formData.displayOrder : qualifiers.length +1,
            'typeName': formData.typeName,
            'visible': formData.visible,
            'selections': formData.typeName && formData.typeName.toLowerCase() === "dropdown" ? selections : null,

        }
        return fieldsSave
    }
    const handleQualifierSubmit = async e => {
        e.preventDefault()
        // add qualifier 
        let req = createSaveRequest();
        try {
            await leadCaptureService.saveQualifier(req);
        } catch (err) {
            console.log(err)
        }

        // reset qualifiers
        let newArray = qualifiers;
        newArray.push(formData);
        setQualifiers(newArray);

        setCreate(false);
        setCreateSelection(false);
        clearForm();
    }
    const createAllSaveRequest = (items) => {
        let tempHolder = []
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            let newObj = {
                id: item.id,
                name: item.name,
                displayOrder: i + 1, // display order starts at 1
                typeName: item.typeName,
                visible: item.visible,
                selections: item.selections && item.typeName.toLowerCase() === "dropdown" ?
                    item.selections : null,
            }
            tempHolder.push(newObj)
        }
            
        const fieldsSave = {
            'exhibitorId': formData.exhibitorId,
            'exhibitorEmail': formData.exhibitorEmail,
            'qualifiers': tempHolder,
        }
        return fieldsSave
    }
    const handleAllQualifierSubmit = (qualifiers) => {
        // add qualifier 
        let req = createAllSaveRequest(qualifiers);
        try {
            leadCaptureService.saveQualifiers(req);
        } catch (err) {
            console.log(err)
        }

        // reset qualifiers
        setCreate(false);
        setCreateSelection(false);
        clearForm();
    }
    const handleQualifierOnDragEnd = (result) => {
        if (!result.destination) return

        const items = Array.from(qualifiers)
        const [reorderedItem] = items.splice(result.source.index, 1)
        items.splice(result.destination.index, 0, reorderedItem)
        setQualifiers(items);
    }
    const handleQualifierSelectionSubmit = async e => {
        e.preventDefault()
        let holder = selections
        if (newSelection && newSelection.length > 0) {
            holder.push(newSelection)
        }
        setSelections(holder);
        setNewSelection('')
        setCreateSelection(false);
    }
    const handleOnDragEnd = (result) => {
        if (!result.destination) return

        const items = Array.from(selections)
        const [reorderedItem] = items.splice(result.source.index, 1)
        items.splice(result.destination.index, 0, reorderedItem)
        setSelections(items);
    }
    function arraymove(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
    }
    
    const submitSelectionEdit = (e, newSelection) => {
        e.preventDefault()
        let divId = parseInt(e.currentTarget.id.replace('edit', ''));
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(selections)
        items.splice(divId, 1);
        items.splice(divId, 0, newSelection);
        cancelSelectionEdit(e);
    }
    const cancelSelectionEdit = e => {
        if (e.currentTarget && e.currentTarget !== undefined) {
            e.preventDefault()
        }
        setSelectionId(null)
    }
    const selectionRemove = e => {
        e.preventDefault()
        const items = Array.from(selections)
        let divId = parseInt(e.currentTarget.id.replace('remove', ''));
        items.splice(divId, 1);
        setSelections(items);
    } 
    const createQualifier = e => {
        e.preventDefault()
        // keeps previous entry, if cancelled
        setCreate(create ? false : true)
    }
    const createQualifierSelection = e => {
        e.preventDefault()
        // keeps previous entry, if cancelled
        setCreateSelection(createSelection ? false : true)
    }
    const qualifierMoveUp = e => {
        e.preventDefault()
        const items = Array.from(qualifiers)
        let divId = parseInt(e.currentTarget.id.replace('up', ''));
        if (divId < 1) {
            // already at top
            return;
        }
        items[divId].editable = false
        setId(null)
        arraymove(items, divId, divId - 1)
        setQualifiers(items);
        handleAllQualifierSubmit(items);
    }
    const qualifierMoveDown = e => {
        e.preventDefault()
        const items = Array.from(qualifiers)
        let divId = parseInt(e.currentTarget.id.replace('down', ''));
        if (divId >= qualifiers.length) {
            // already at bottom
            return;
        }
        items[divId].editable = false
        setId(null)
        arraymove(items, divId, divId + 1)
        setQualifiers(items);
        handleAllQualifierSubmit(items);
    }
    const fetchQualifierTypes = async () => {
        let qualifiersList = await leadCaptureService.getQualifierTypeOptions();
        if (qualifiersList && qualifiersList.length > 0) {
            setQualifierTypes(qualifiersList);
        }
    };
    const fetchQualifiers = async (id) => {
        let qualifiersList = await leadCaptureService.getExhibitorQualifiers(exhibitor.id);
        if (qualifiersList && qualifiersList.length > 0) {
            setQualifiers(qualifiersList);
        }
    };
    const isFormValid = () => {
        return !createSelection && formData.exhibitorId
            && formData.name
            && ((formData.typeName && formData.typeName.toLowerCase() === "dropdown" && selections && selections.length > 0)
            || (formData.typeName && formData.typeName.toLowerCase() !== "dropdown"))
            ? true
            : false
    }
    useEffect(() => {
        if (qualifierTypes && qualifierTypes.length > 0) {
            fetchQualifiers();
        }
        setLoaded(true);
    }, [qualifierTypes])
    useEffect(() => {
        // used for dropdowns
        fetchQualifierTypes();
    }, [])
    return (
        <div id={styles.eventConfigurePage}>
            <h1>Qualifier Management</h1><br />
            <h2>Mobile App qualifier setup for {exhibitor.firstName} {exhibitor.lastName} - {exhibitor.organization} ({exhibitor.refNumber}).</h2><br />
            <>
                {
                    !loaded ? <LoadingSpinner /> :
                        <>
                            <br />
                            <p>
                                <strong>Name:</strong> The qualifier value to be displayed in lead retrieval app for exhbitor to select.<br />
                                <strong>Type:</strong> Qualifier types: Checkbox, Label, Dropdown, or Textbox.<br />
                                <strong>Selections:</strong> Only used for dropdown qualifiers.<br />
                                <strong>Visible:</strong>  Hides the qualifier if exhibitor no longer wants to use it, but can&apos;t immediately remove the qualifier b/c it&apos;s been used.<br />
                                &emsp;&emsp;&emsp;<i>*Updating leads will remove qualifier from reports, unless still in use by other leads. </i><br />
                                <strong>Order:</strong> Allows exhibitors to change the qualifier ordering. (Drag and drop)<br />
                                <strong>Remove:</strong> Allows for removal of qualifier &mdash; assuming that it hasn&apos;t been used yet.<br />
                            </p>
                            <br />
                            <h3 class="text-danger">
                                <strong>Qualifier "Notes" already exists and is part of every lead, by default! </strong>
                            </h3>
                            <div className={styles.formQualifierContainer}>
                                <button onClick={createQualifier} >
                                    {!create ? "Add New Qualifier" : "Cancel"}
                                </button><br />
                            </div>
                            {
                                create ?
                                    <>
                                        <div className={styles.formqualifierContainer}>
                                            <form
                                                autoComplete="off"
                                                onSubmit={handleQualifierSubmit}
                                                className={styles.container}
                                            >
                                                <div className={styles.inputContainer}>
                                                    <label htmlFor="name" title='Qualifier display name.' className={styles.label}>Name:</label>
                                                    <textarea
                                                        autoComplete="off"
                                                        value={formData.name}
                                                        name="name"
                                                        rows="2"
                                                        cols="35"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className={styles.inputContainer}>
                                                    <label htmlFor="typeName" title='Qualifier type.' className={styles.label}>Type:</label>
                                                    <select
                                                        name="typeName"
                                                        id={styles.ThirdPartyListDropdown}
                                                        value={formData.typeName}
                                                        onChange={handleChange}
                                                    >
                                                        <option disabled={true} value="" selected="selected">
                                                            -- Select an option --
                                                        </option>
                                                        {
                                                            qualifierTypes.map((ci, idx) => (
                                                                <option key={idx}>{ci.name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div><br />
                                                <div className={styles.inputContainer}>
                                                    <>{formData.typeName && formData.typeName.toLowerCase() === 'dropdown' ?
                                                        <>
                                                            <div className={styles.formQualifierContainer}>
                                                                <button onClick={createQualifierSelection} style={{ marginRight: '20px' }} >
                                                                    {!createSelection ? "Add New Selection" : "Cancel"}
                                                                </button>
                                                                {createSelection ?
                                                                    <button className={styles.button} onClick={handleQualifierSelectionSubmit}>
                                                                    Add
                                                                </button> : <></>}

                                                            </div>
                                                            {
                                                                createSelection ?
                                                                    <>
                                                                        <div className={styles.inputContainer}>
                                                                            <label htmlFor="name" title='Qualifier selection option.' className={styles.label}>Entry:</label>
                                                                            <textarea
                                                                                autoComplete="off"
                                                                                value={newSelection}
                                                                                name="newSelection"
                                                                                rows="2"
                                                                                cols="35"
                                                                                onChange={handleSelectionChange}
                                                                            />
                                                                        </div>
                                                                    </> : <></>
                                                            }
                                                            <br />
                                                            <>
                                                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                                                    <Droppable droppableId="boxes">
                                                                        {(provided) => (
                                                                            <table className={styles.tableQualifiers}>
                                                                                <thead>
                                                                                    <tr className={styles.trQualifiers}>
                                                                                        <th className={styles.thQualifiers}>
                                                                                            Order
                                                                                        </th>
                                                                                        <th className={styles.thQualifiers}>
                                                                                            Entry
                                                                                        </th>
                                                                                        <th className={styles.thQualifiers}>
                                                                                            Remove
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody key={selections.length} {...provided.droppableProps} ref={provided.innerRef}>
                                                                                    {selections.map((item, index) => (
                                                                                        <Draggable key={index} draggableId={index.toString()} index={index}>
                                                                                            {(provided) => (
                                                                                                <QualifierSelection
                                                                                                    qualifierEntry={item}
                                                                                                    removeSelection={selectionRemove}
                                                                                                    submitEdit={submitSelectionEdit}
                                                                                                    index={index}
                                                                                                    key={item + index}
                                                                                                    provided={provided}
                                                                                                    innerRef={provided.innerRef}>
                                                                                                </QualifierSelection>
                                                                                            )}
                                                                                        </Draggable>
                                                                                    ))}
                                                                                </tbody>

                                                                            </table>


                                                                        )}
                                                                    </Droppable>
                                                                </DragDropContext>

                                                            </>
                                                           
                                                            
                                                        </>

                                                        :
                                                        <></>
                                                    }
                                                    </>

                                                </div>
                                                <br />
                                                <div className={styles.inputContainer}>
                                                    <button disabled={!isFormValid()} className={styles.button}>
                                                        Save Qualifier
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                    </>
                                    :
                                    <></>
                            }
                            {qualifiers && qualifiers.length > 0 ?
                                <>
                                    <br /><br />
                                    <DragDropContext onDragEnd={handleQualifierOnDragEnd}>
                                        <Droppable droppableId="boxes">
                                            {(provided) => (
                                                <table className={styles.tableQualifiers}>
                                                    <thead>
                                                        <tr className={styles.trQualifiers}>
                                                            <th className={styles.thQualifiers}>
                                                                Order
                                                                <HoverButton
                                                                    title={'Change qualifier order'}
                                                                    messageWidth={75}
                                                                />
                                                            </th>
                                                            <th className={styles.thQualifiers}>
                                                                Name
                                                                <HoverButton
                                                                    title={'Qualifier name'}
                                                                    messageWidth={75}
                                                                />
                                                            </th>
                                                            <th className={styles.thQualifiers}>
                                                                Type
                                                                <HoverButton
                                                                    title={'Qualifier type'}
                                                                    messageWidth={75}
                                                                />
                                                            </th>
                                                            <th className={styles.thQualifiers}>
                                                                Selections
                                                                <HoverButton
                                                                    title={'Qualifier selection options'}
                                                                    messageWidth={75}
                                                                />
                                                            </th>
                                                            <th className={styles.thQualifiers}>
                                                                Visible
                                                                <HoverButton
                                                                    title={'Flag for qualifier visibility'}
                                                                    messageWidth={75}
                                                                />
                                                            </th>
                                                            <th className={styles.thQualifiers}>User Actions
                                                                <HoverButton
                                                                    title={'User options.'}
                                                                    messageWidth={75}
                                                                /></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody key={qualifiers.length} {...provided.droppableProps} ref={provided.innerRef}>
                                                        {qualifiers.map((item, index) => (
                                                            <Draggable key={index} draggableId={index.toString()} index={index}>
                                                                {(provided) => (
                                                                     <QualifierSetup
                                                                        index={index}
                                                                        qualifierItem={item}
                                                                        qualifierTypes={qualifierTypes}
                                                                        total={qualifiers.length}
                                                                        qualifierMoveUp={qualifierMoveUp}
                                                                        qualifierMoveDown={qualifierMoveDown}
                                                                        deleteQualifier={deleteQualifier}
                                                                        editQualifier={editQualifier}
                                                                        cancelEdit={cancelEdit}
                                                                        key={item.name + index}
                                                                        editingId={editingId}
                                                                        provided={provided}
                                                                        innerRef={provided.innerRef}>
                                                                    </QualifierSetup>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                    </tbody>

                                                </table>


                                            )}
                                        </Droppable>
                                    </DragDropContext>

                                </>

                                :
                                <><br /><br /><div> No qualifiers found.</div></>
                                }
                            
                        </>
                }
            </>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default QualifierManager;